import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../configure_store'

const _getState = (state: RootState) => state.notifications

export const getNotifications = createSelector(_getState, (state) => [...state.notifications].sort((a, b) =>
  new Date(b.startDate).getTime() > new Date(a.startDate).getTime() ? 1 : -1
))

export const getNotification = () =>
  createSelector(_getState, (state) =>
    state.notification
  )

export const getUnreadNotificationsCount = createSelector(_getState, (state) => {
  if (!state.notifications) {
    return 0
  }

  return state.notifications.filter((notification) => !notification.readAt).length
})

export const getNotificationsIsLoading = createSelector(_getState, (state) => state.isLoading)
export const getNotificationsLastFetchedAt = createSelector(_getState, (state) => state.lastFetchedAt)
